// cortona3d/util.js

/**
 * @module cortona3d/util
 */

module.exports = {
    extend: extend,
    defineClass: defineClass,
    expand: expand,
    RGB: RGB,
    fromHTMLColor: fromHTMLColor,
    loadScript: loadScript,
    loadStyleSheet: loadStyleSheet,
    isFunction: isFunction,
    isNumber: isNumber,
    isString: isString,
    isObject: isObject,
    isPromise: isPromise,
    isHTMLNode: isHTMLNode,
    isUndefined: isUndefined,
    detectAMDLoader: detectAMDLoader,
    getBaseURL: getBaseURL,
    loadResource: loadResource,
    toggleClass: toggleClass
};


// Array.isArray polyfill
if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

/*
 */
function extend(f) {
    function G() {}
    G.prototype = f.prototype || f;
    return new G();
}

/** 
 * Utility function for defining a new class.
 *
 * @param parent {Function} the parent class of the new class or null
 * @param ctor {Function} the constructor of the new class
 * @param methods {Object} an object literal containing the methods of the new class
 * @return {Function} the constructor function of the new class
 */
function defineClass(parent, ctor, methods) {
    function Inheritance() {}
    if (parent) {
        Inheritance.prototype = parent.prototype;
        ctor.prototype = new Inheritance();
        ctor.prototype.constructor = ctor;
        ctor.superClass = parent;
    }
    if (methods) {
        for (var m in methods) {
            if (methods.hasOwnProperty(m)) {
                ctor.prototype[m] = methods[m];
            }
        }
    }
    return ctor;
}

/**
 * @param obj {Object}
 * @param [props, ...] {Object}
 */
function expand(obj) {
    for (var i = 1; i < arguments.length; i++) {
        var props = arguments[i];
        if (!isObject(props)) continue;
        for (var key in props) {
            if (props.hasOwnProperty(key)) {
                if (key in obj) {
                    if (isFunction(obj[key]) && isFunction(props[key])) {
                        obj[key] = props[key];
                    } else if (Array.isArray(obj[key]) && Array.isArray(props[key])) {
                        obj[key] = props[key];
                    } else if (isObject(obj[key]) && isObject(props[key]) && props[key] !== {}) {
                        expand(obj[key], props[key]);
                    } else {
                        obj[key] = props[key];
                    }
                } else {
                    obj[key] = props[key];
                }
            }
        }
    }
    return obj;
}

/**
 * @param r {Number} [0...255]
 * @param g {Number} [0...255]
 * @param b {Number} [0...255]
 * @return {Number} 
 */
function RGB(r, g, b) {
    return (r + g * 256 + b * 65536);
}

/**
 * @param color {string} HTML HEX color
 * @return {Number} 
 */
function fromHTMLColor(color) {
    if (isNumber(color)) return color;
    if (isString(color) && color.match(/^#?([0-9A-F]{6})$/i)) {
        return parseInt(
            RegExp.$1.substr(4, 2) +
            RegExp.$1.substr(2, 2) +
            RegExp.$1.substr(0, 2), 16);
    }
    return 0;
}

/**
 * @callback requestCallback
 */

/**
 * @param fileName {string} url for loading
 * @param [async] {boolean} async attribute
 * @param  resolve {requestCallback}
 * @returns {HTMLElement}
 * @memberof cortona3d
 */
function loadScript(fileName, async, resolve, reject) {
    var scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = fileName;
    if (!isUndefined(async)) {
        scriptElement.async = !!async;
    }
    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(scriptElement);
    return scriptElement;
}

/**
 * @param fileName {string} url for loading
 * @param  resolve {requestCallback}
 * @returns {HTMLElement}
 * @memberof cortona3d
 */
function loadStyleSheet(fileName, resolve, reject) {
    var linkElement = document.createElement('link');
    linkElement.href = fileName;
    linkElement.rel = 'stylesheet';
    linkElement.type = 'text/css';
    linkElement.onload = resolve;
    linkElement.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(linkElement);
    return linkElement;
}

/**
 * @param arg {object} 
 * @return {boolean} 
 */
function isFunction(arg) {
    return typeof arg === 'function';
}

/**
 * @param arg {object} 
 * @return {boolean} 
 */
function isNumber(arg) {
    return typeof arg === 'number';
}

/**
 * @param arg {object} 
 * @return {boolean} 
 */
function isString(arg) {
    return typeof arg === 'string';
}

/**
 * @param arg {object} 
 * @return {boolean} 
 * @memberof cortona3d
 */
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}

/**
 * @param arg {object} 
 * @return {boolean} 
 * @memberof cortona3d
 */
function isPromise(arg) {
    return Object.prototype.toString.call(arg) === '[object Promise]' || (
        isObject(arg) && isFunction(arg.then) && isFunction(arg.catch) && isFunction(arg.finally)
    );
}

/**
 * @param arg {object} 
 * @return {boolean} 
 * @memberof cortona3d
 */
function isHTMLNode(arg) {
    return arg instanceof Node || /^\[object HTML.*Element]$/.test(Object.prototype.toString.call(arg));
}

/**
 * @param arg {object} 
 * @return {boolean} 
 */
function isUndefined(arg) {
    return arg === void 0;
}

/**
 * @return {boolean}
 */
function detectAMDLoader() {
    return isFunction(window.requirejs) && (isFunction(window.define) && window.define.amd);
}

/**
 * @param [url] {string} 
 * @return {string} 
 * @memberof cortona3d
 */
function getBaseURL(url) {
    if (typeof url !== 'string') {
        url = '#';
    }
    // check is data URI
    if (!/^[a-z]+\:\/\//i.test(url) && !/^\/\//.test(url) && /^[a-z]+\:/i.test(url)) {
        return "";
    }
    var a = document.createElement('a');
    a.href = url;
    a = a.cloneNode(false);
    url = a.protocol + '//' + a.host + (a.pathname[0] === '/' ? '' : '/') + a.pathname;
    return url.substring(0, url.lastIndexOf('/') + 1);
}


/**
 * Loads a resource from url using XMLHttpRequest
 * @param {string} url 
 * @param {string} [overrideMimeType]
 * @param {string} [responseType]
 * @return promise<xhr>
 */
function loadResource(url, overrideMimeType, responseType) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();

        if (overrideMimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(overrideMimeType);
        }

        xhr.open("GET", url, true);

        if (responseType) {
            xhr.responseType = responseType;
        }

        function errorHandler(e) {
            if (window.Cortona3DSolo) window.Cortona3DSolo.dispatch('app.onProgress', 0, -1, e.type);
        }

        xhr.onprogress = function (e) {
            var loaded = e.loaded,
                total = e.lengthComputable || e.lengthComputable === undefined ? e.total : 0;
            if (window.Cortona3DSolo) window.Cortona3DSolo.dispatch('app.onProgress', loaded, total, e.type);
        };
        xhr.onabort = errorHandler;
        xhr.onerror = errorHandler;
        xhr.onload = errorHandler;
        xhr.onreadystatechange = function (e) {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200 || xhr.status === 0) {
                    resolve(xhr);
                } else {
                    reject(new Error(url + " " + xhr.status + " " + xhr.statusText));
                }
            }
        };
        try {
            xhr.send(null);
        } catch (e) {
            reject(e);
        }
    });
}

/**
 * @param element {HTMLElement} 
 * @param className {string} 
 * @param flag [{boolean}]
 */
function toggleClass(element, className, flag) {
    if (element) {
        flag = isUndefined(flag) ? !element.classList.contains(className) : flag;
        if (flag) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }
}